export default __webpack_public_path__ + "static/media/Group9213.8a721d24.svg";